import { api } from './client';
import type { Uuid } from '../types/api';

/**
 * Presigned GET URL for the invoice PDF. Short-lived (30s on the server);
 * callers open it immediately rather than stash the URL. Returns 404 until
 * the invoice-pdf worker finishes — UI should show "Generating…" and
 * re-fetch on the `invoice:pdf_ready` WS system event.
 */
export interface InvoiceDownloadResponse {
  url: string;
  expiresInSeconds: number;
  expiresAt: string;
}

export async function getInvoiceDownloadUrl(id: Uuid): Promise<InvoiceDownloadResponse> {
  const { data } = await api.get<InvoiceDownloadResponse>(`/invoices/${id}/download`);
  return data;
}
